<template>
    <base-layout title="完善信息" :hideHeader="true">
        <template slot="main">
            <!-- 未成年人协议 -->
            <ui-dialog
                v-model="showMinorPrivacyProtocol"
                :title="protocolContent && protocolContent.title?protocolContent.title:' 达美乐未成年人和儿童个人信息保护政策'"
                :showCancel="true"
                confirmText="同意"
                cancelText="不同意"
                :closeOnClickOverlay="false"
                :beforeCancel="beforeCancelMinorProtocol"
                :beforeConfirm="beforeConfirmMinorProtocol"
            >
                <div class="dialog-content">
                    <div v-if="!protocolContent" style="padding-top: 150px;">
                        <loading text="协议获取中..." :message="errMsg"/>
                    </div>
                    <div v-else class="docs ql-editor" v-html="protocolContent.content">

                    </div>
                </div>
            </ui-dialog>

            <!-- 活动说明 -->
            <ui-dialog
                :showCancel="false"
                confirmText="知道了"
                :titleStyle="{fontSize:'14px'}"
                v-model="activityExplainShow"
                title=""
            >
                <div class="dialog-content">
                    <!--                    <improve-information :isShowHeader="false"/>-->
                    <comm-protocol :isShowHeader="false" protocolCode="completeInfoagreement"/>
                </div>
            </ui-dialog>
            <!-- 手机号码绑定 -->
            <bind-phone v-model="showBindPhone"
                        :memberProtocol="isMemberProtocol"
                        @close="scrollShim"
                        :hidden="showCity"
                        :city.sync="cityName"
                        trackName="完善信息"
                        title="轻松绑定，各类优惠券可自动放入卡包！"
                        :joinCityCode.sync="joinCityCode"
                        :showCity.sync="showCity"
                        @success="successBind"
                        @openMemberProtocol="openMemberProtocol"
            />
            <!-- 会员章程 -->
            <ui-dialog
                v-model="showMemberProtocol"
                :title="memberProtocolTitle"
                :showCancel="memberProtocolShowCancel"
                :confirmText="memberProtocolConfirmText"
                :beforeConfirm="beforeConfirmProtocol"
                :beforeCancel="beforeCancelProtocol"
            >
                <member-rules showType="simple" :isShowHeader="false" @toggle="memberProtocolToggle"
                              :title.sync="memberProtocolTitle"/>
            </ui-dialog>

            <!-- 性别 -->
            <popup v-model="showSex" position="bottom" @open="sexOpen">
                <picker ref="sexPicker" :columns="[{
                          values: sexList,
                          defaultIndex: 0
                        }]"
                        show-toolbar
                        title=""
                        @cancel="showSex=false"
                        @confirm="sexSelect"/>
            </popup>

            <!-- 家庭人数选择 -->
            <popup v-model="showFamily" position="bottom" @open="familyOpen">
                <picker
                    ref="familyPicker"
                    :columns="[{
                          values: familyList,
                          defaultIndex: 0
                        }]"
                    show-toolbar
                    title
                    :value="selectFamilyName"
                    value-key="name"
                    @cancel="showFamily=false"
                    @confirm="familySelcet"
                />
            </popup>

            <!-- 用户生日 -->
            <popup v-model="showBirthday" position="bottom">
                <datetime-picker
                    :value="selectBirthdayValue?new Date(selectBirthdayValue):dateUtils.convert(new Date().setFullYear(new Date().getFullYear() - 1))"
                    type="date"
                    :min-date="minBirth"
                    :max-date="maxBirth"
                    @confirm="beforeUpdateBirthday"
                    :formatter="formatter"
                    @cancel="showBirthday=false"
                />
            </popup>

            <!-- 宝宝人数选择 -->
            <popup v-model="showBaby" position="bottom" @open="babyOpen">
                <picker
                    ref="babyPicker"
                    :columns="[{
                          values: babyList,
                          defaultIndex: 0
                        }]"
                    show-toolbar
                    title
                    :value="selectBabyText"
                    value-key="text"
                    @cancel="showBaby=false"
                    @confirm="babySelcet"
                />
            </popup>

            <!-- 宝宝生日 -->
            <popup v-model="showBabyBirthday" position="bottom">
                <datetime-picker
                    :value="babyInfoList[selectBabyIndex] && babyInfoList[selectBabyIndex].birthday?dateUtils.convert(babyInfoList[selectBabyIndex].birthday):dateUtils.convert(new Date().setFullYear(new Date().getFullYear() - 1))"
                    type="year-month"
                    :min-date="minBabyBirthday"
                    :max-date="maxBirthday"
                    @confirm="selectBabyBirthday"
                    :formatter="formatter"
                    @cancel="showBabyBirthday=false"
                />
            </popup>

            <div class="member-body" ref="memberMain">
                <div class="member-nav" :style="navStyle">
                    <ul class="title-container">
                        <li @click="backPage()">
                            <i class="dmicon dm-xiangzuojiantou"></i>
                            <span>返回</span>
                        </li>
                        <li>
                            <span>完善信息</span>
                        </li>
                        <li class="title-right">

                        </li>
                    </ul>
                </div>
                <div class="main-body-content" @scroll.passive="paperScroll($event)">
                    <div class="gift-container">
                        <div class="gift-header">
                            <img src="~@app/my/personalInfo/_img/wx_infoTop_new.png"/>
                            <div class="gift-content">
                                <div class="gift-describe">
                                    <template v-if="!isSendMarketing">
                                        <h5>会员完善信息</h5>
                                        <h5>可获得20积分奖励</h5>
                                        <h5 v-if="isLoyalty">您已是会员，快快完善吧！</h5>
                                        <router-link v-if="!isLoyalty" to="/my/member/index" tag="p">
                                            <h5 class="join">您还不是会员</h5>
                                            <h5 class="join">加入达人荟>></h5>
                                        </router-link>
                                    </template>
                                    <h5 v-if="isSendMarketing">
                                        {{ marketingDate|formatTime('m月d日') }}您已获得
                                        <h5>该完善信息得积分奖励，</h5>
                                        <h5>可更新信息哦！</h5>
                                    </h5>
                                </div>
                            </div>
                            <div class="header-cover">
                            </div>
                        </div>
                        <div class="gift-user-info">

                            <div class="user-form" @click.capture="chechAnonymous">
                                <!--<div class="btn-show">
                                    <span>立即完善信息，获得额外20积分奖励!</span>
                                </div>-->
                                <ul>
                                    <!-- 姓名 -->
                                    <li>
                                        <div class="input-container">
                                            <strong>
                                                <img src="~@app/my/member/_img/memberSelectGift/icon-1.png">
                                                <span>昵称</span>
                                            </strong>
                                            <input name="name" type="text" v-model.trim="name" placeholder="请填写昵称"
                                                   v-validate="{nickname:true,max:16}"/>
                                            <i class="dmicon dm-xiangyoujiantou"></i>
                                        </div>
                                    </li>
                                    <!-- 性别 -->
                                    <li>
                                        <div class="input-container" @click="showSex=true">
                                            <strong>
                                                <img src="~@app/my/member/_img/memberSelectGift/icon-2.png">
                                                <span>性别</span>
                                            </strong>
                                            <p :class="{exist:selectSexValue != null}">{{
                                                    selectSexValue !=
                                                    null ? sexList.find(info => info.value == selectSexValue).text : "请选择"
                                                }}</p>
                                            <i class="dmicon dm-xiangyoujiantou"></i>
                                        </div>
                                    </li>
                                    <!-- 生日 -->
                                    <li>
                                        <div :class="{disable:!!isInitBirthday}" class="input-container"
                                             @click="selectBirthday">
                                            <strong>
                                                <img src="~@app/my/member/_img/memberSelectGift/icon-3.png">
                                                <span>生日</span>
                                            </strong>
                                            <p :class="{exist:!!selectBirthdayValue}">{{
                                                    selectBirthdayValue
                                                        ? selectBirthdayText : "设置生日，设置后不可修改"
                                                }}</p>
                                            <i class="dmicon dm-xiangyoujiantou"></i>
                                        </div>
                                    </li>
                                    <!-- 邮箱 -->
                                    <!--                                    <li :class="{err:errors.has('mail')}">
                                                                            <div class="input-container">
                                                                                <strong>
                                                                                    <img src="~@app/my/member/_img/memberSelectGift/icon-4.png">
                                                                                    <span>邮箱</span>
                                                                                </strong>
                                                                                <input name="mail" v-model="email" v-validate="{ email:true}" type="text"
                                                                                       placeholder="填写邮箱，以获取优惠信息"/>
                                                                                <i class="dmicon dm-xiangyoujiantou"></i>
                                                                            </div>
                                                                        </li>-->
                                    <!-- 手机号 -->
                                    <li @click="chechBindPhone">
                                        <div class="input-container">
                                            <strong>
                                                <img src="~@app/my/member/_img/memberSelectGift/phone.png">
                                                <span>手机号</span>
                                            </strong>
                                            <p class="exist" v-if="cellPhone">
                                                {{ cellPhone | encryptPhone }}</p>
                                            <p v-else>绑定手机号码以便查看优惠券</p>
                                            <i class="dmicon dm-xiangyoujiantou"></i>
                                        </div>
                                    </li>
                                    <!-- 家庭成员人数（含本人） -->
                                    <!--<li>
                                        <div class="input-container" @click="showFamily=true">
                                            <strong>
                                                <img src="~@app/my/member/_img/memberSelectGift/icon-5.png">
                                                <span>家庭成员人数（含本人）</span>
                                            </strong>
                                            <p :class="{exist:!!selectFamilyValue }">{{
                                                    selectFamilyValue
                                                        ? selectFamilyName : "请选择"
                                                }}</p>
                                            <i class="dmicon dm-xiangyoujiantou"></i>
                                        </div>
                                    </li>-->
                                    <!-- 6岁以下宝宝人数 -->
                                    <!--                                    <li>
                                                                            <div class="input-container" @click="showBabyOpen">
                                                                                <strong>
                                                                                    <img src="~@app/my/member/_img/memberSelectGift/icon-6.png">
                                                                                    <span>12岁以下宝宝人数</span>
                                                                                </strong>
                                                                                <p :class="{exist:selectBabyValue}">
                                                                                    {{
                                                                                        selectBabyValue !== null ? babyList.find(info => info.value ==
                                                                                            selectBabyValue).text : "请选择"
                                                                                    }}</p>
                                                                                <i class="dmicon dm-xiangyoujiantou"></i>
                                                                            </div>
                                                                            <div class="baby-list-main" v-if="babyInfoList.length">
                                                                                <p>填写宝宝信息以便获得宝宝活动通知</p>
                                                                                <ul class="baby-list-container">
                                                                                    <li v-for="(info,index) in babyInfoList" class="baby-info"
                                                                                        @click="openBabyInfo(index)">
                                                                                        <strong>第{{ index + 1 }}个宝宝</strong>
                                                                                        <div class="baby-info-select-input">
                                                                                            <p :class="{exist:info.birthday != null}">{{
                                                                                                    info.birthday
                                                                                                        ? info.birthdayText : "选择年份，限制当前年-12"
                                                                                                }}</p>
                                                                                            <i class="dmicon dm-dengdai"></i>
                                                                                        </div>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>-->

                                </ul>
                            </div>

                            <!-- 活动说明 -->
                            <div class="activity-explain" @click="activityExplainShow=true">
                                <img src="./_img/wx_infoRules.png" alt="">
                            </div>

                            <div class="form-submit" @click.capture="chechAnonymous">
                                <img src="./_img/wx_infoConfirm.png" alt="" @click="updateUserInfo">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
// 大邦图标组件
import dIcon from '@components/comm/d-icon.vue'
import baseLayout from '@comm/view/layout/baseLayout';
import circleProgress from '@components/comm/circle-progress.vue'
// 手机号码绑定弹窗
import bindPhone from '@components/comm/bindPhone-popup'
// loading加载
import loading from '@components/comm/loading'
// 有赞组件库
import {DatetimePicker, picker, Dialog, Toast} from 'vant';
import popup from "@components/popup";
import uiDialog from '@components/dialog'
import MemberRules from '@app/system/protocol/memberRules.vue';
// 时间处理
import DATE, {isLtAge} from '@utils/date'
// 达人荟会员“完善信息得积分”的活动规则
// import improveInformation from '@app/system/protocol/improveInformation'
import commProtocol from '@app/system/protocol/commProtocol'
// 用户存储
import userStore, {
    isAgreeMinorAgreement, agreeMinorAgreement,
    minBirth,
    maxBirth
} from '@comm/store/user/userInfo.store.js'
import Vue from "vue";
import {CMS_Methods} from "@comm/store/cms.store";
import {Base64} from "js-base64";

const $Date = DATE.date;

// 接口字段转换字典
const filedMap = {
    // 邮箱
    email: 'email',
    // 宝宝信息列表
    asUserFamilyList: 'babyInfoList',
    // 宝宝数
    babyNumber: 'selectBabyValue',
    // 生日
    birthday: 'selectBirthdayValue',
    // 手机
    cellPhone: 'cellPhone',
    // 家庭人数
    familySize: 'selectFamilyValue',
    // 会员等级
    isLoyalty: 'isLoyalty',
    // 用户姓名
    name: 'name',
    // 是否发送过营销积分
    sendMarketingPoint: 'isSendMarketing',
    // 营销积分发送时间
    sendMarketingPointDate: 'marketingDate',
    // 性别
    sex: 'selectSexValue',
};

export default {
    name: 'myPersonalInfoUpdateUserInfo',
    components: {
        popup,
        dIcon,
        picker,
        loading,
        uiDialog,
        bindPhone,
        baseLayout,
        MemberRules,
        circleProgress,
        DatetimePicker,
        // improveInformation,
        commProtocol,
    },
    data() {
        // 家庭人数选择列表
        const familyList = [
            // {name: "请选择", value: null},
            {name: "1位", value: 1},
            {name: "2位", value: 2},
            {name: "3位", value: 3},
            {name: "4位", value: 4},
            {name: "5位", value: 5},
            {name: "6位", value: 6},
            {name: "7位", value: 7},
        ];
        // 性别列表
        const sexList = [
            // {text: '请选择', value: null},
            {text: '保密', value: 0},
            {text: '男', value: 1},
            {text: '女', value: 2},
        ];
        // 宝宝人数列表
        const babyList = [
            // {text: "请选择", value: null},
            {text: "暂时没宝宝", value: 0},
            {text: "1个", value: 1},
            {text: "2个", value: 2},
            {text: "3个", value: 3}
        ]
        // 宝宝最小日期 （当前时间 - 12 岁）
        const minBabyBirthday = new Date();
        minBabyBirthday.setFullYear((minBabyBirthday.getFullYear() - 12));

        return {
            // 是否匿名用户
            anonymous: false,
            // 是否请求状态中
            isRequest: false,
            // 用户名称
            name: null,
            // 会员等级
            isLoyalty: 0,
            // 是否发送过营销积分
            isSendMarketing: false,
            // 营销积分发放时间
            marketingDate: null,
            // 邮箱
            // email: null,
            // 手机号
            cellPhone: null,
            // 家庭人数列表
            familyList,
            // 家庭人数展示控制
            showFamily: false,
            // 选择的家庭名称
            selectFamilyName: null,
            selectFamilyValue: null,
            // 性别列表
            sexList,
            // 性别展示控制
            showSex: false,
            // 选择的性别
            selectSexValue: null,
            // 生日显示控制
            showBirthday: false,
            // 生日
            isInitBirthday: false,
            selectBirthdayText: null,
            selectBirthdayValue: null,
            selectTemptBirthday: null,
            // 最大生日
            maxBirthday: new Date(),
            // 宝宝人数列表
            babyList,
            // 宝宝人数展示控制
            showBaby: false,
            // 选择的宝宝数量
            selectBabyText: null,
            selectBabyValue: null,
            // 宝宝信息列表
            babyInfoList: [],
            // 宝宝信息选择的索引
            selectBabyIndex: 0,
            // 宝宝生日显示控制
            showBabyBirthday: false,
            // 宝宝生日最小日期
            minBabyBirthday,
            // 滚动比例
            scrollScale: 0,
            // 确定后是否返回上一页
            isBack: false,
            // 时间处理库
            dateUtils: $Date,
            // 绑定手机
            showBindPhone: false,
            isMemberProtocol: false,
            showCity: false,
            cityName: '加载中...',
            joinCityCode: '',
            // 会员章程弹窗标题
            showMemberProtocol: false,
            memberProtocolTitle: '会员章程',
            memberProtocolShowCancel: true,
            memberProtocolConfirmText: '确定',
            // 活动说明弹窗
            activityExplainShow: false,
            // 会员章程code
            memberAgreementCode: 'memberagreement',
            // 当前会员协议信息
            nowMemberProtocolInfo: {},
            // 是否展示未成年协议
            showMinorPrivacyProtocol: false,
            // 错误信息
            errMsg: null,
            protocolContent: null,
            // 最小可选生日
            minBirth: minBirth(),
            // 最大可选生日
            maxBirth: maxBirth(),
        }
    },
    created() {
        // 个性化message
        this.$validator.localize('zh_CN', {
            custom: {
                /*mail: {
                    email: "邮箱格式错误"
                },*/
                name: {
                    max: '昵称不能超过16个字符',
                    nickname: '昵称不能包含特殊字符',
                }
            }
        });
        // 用户数据加载
        this.request();
    },
    mounted() {
        // cms - 获取未成年协议
        CMS_Methods.getProtocol('nonageagreement').then(info => {
            this.protocolContent = info
        }, errMsg => this.errMsg = errMsg)
    },
    methods: {
        // 用户数据请求
        request() {
            return new Promise((resolve, reject) => {
                Toast.loading({
                    mask: false,         // 是否显示背景蒙层
                    duration: 0,        // 持续展示 toast
                    forbidClick: true,  // 禁用背景点击
                    loadingType: 'spinner',
                    message: '数据获取中...'
                });
                // 用户数据获取
                this.$service('getAsUserInfo').success(res => {
                    // 手机号码解密
                    if (res.cellPhone && /[a-z]$/i.test(res.cellPhone)) {
                        res.cellPhone = Base64.decode(decodeURIComponent(res.cellPhone))
                    }
                    Toast.clear();
                    // 字段转换
                    Object.keys(filedMap).forEach(key => {
                        let nowKey = filedMap[key];
                        this[nowKey] = res[key] == null ? this[nowKey] : res[key];
                    });

                    // 初始化生日
                    if (this.selectBirthdayValue) {
                        // 是否已经设置生日
                        this.isInitBirthday = true;
                        this.selectBirthdayText = $Date.convert(this.selectBirthdayValue, "yy年mm月dd日");
                    }

                    // 家庭人数
                    if (this.selectFamilyValue) {
                        this.selectFamilyName = (this.familyList.find(info => info.value == this.selectFamilyValue) || {}).name;
                    }

                    // 是否匿名用户
                    this.anonymous = res.anonymousFlag == 1;

                    this.babyInfoList = (this.babyInfoList.length ? this.babyInfoList : new Array(res.babyNumber || 0).fill({})).map(info => {
                        return {
                            ...info,
                            birthdayText: $Date.convert(info.birthday, "yy年mm月"),
                        };
                    })
                    resolve();
                }).error(errMsg => {
                    Toast.clear();
                    Toast(errMsg);
                    reject(errMsg);
                    return Dialog.confirm({
                        message: '亲，您未登录，请登录~',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: '去登录'
                    }).then(() => {
                        // 记录未登录时候的地址
                        userStore.commit('recordNotLogin');
                        this.$router.push('/login');
                    }).catch(() => {
                        // on cancel
                    });

                }).send({
                    encodedPhone: 'ok'
                });
            })
        },
        // 页面滚动
        paperScroll(event) {
            let srcElement = event.srcElement;
            let scrollTop = srcElement.scrollTop;
            let gap = 50 - scrollTop;
            let scale = 1;
            if (gap > 0) {
                scale = scrollTop / 50;
            }
            this.scrollScale = scale;
        },
        // 更新用户信息
        updateUserInfo() {
            // 字段校验
            this.$validator.validateAll().then(poss => {

                if (this.babyInfoList.some(info => !info.birthday)) {
                    return Toast('请选择宝宝生日');
                }

                if (poss) {
                    if (this.isRequest) return
                    this.isRequest = true;
                    // 字段转换
                    const sendData = Object.keys(filedMap).reduce((sendData, key) => {
                        let nowKey = filedMap[key];
                        sendData[key] = this[nowKey];
                        return sendData;
                    }, {});

                    // 是否
                    if (this.isInitBirthday) {
                        sendData.birthday = null;
                    }

                    // 用户名处理
                    sendData.name = (sendData.name || '').replace(/\s*([\S]*)\s*/, '$1');
                    Toast.loading({
                        mask: false,         // 是否显示背景蒙层
                        duration: 0,        // 持续展示 toast
                        forbidClick: true,  // 禁用背景点击
                        loadingType: 'spinner',
                        message: '数据更新中...'
                    });

                    // CDP埋点 [完善个人信息]
                    this.$CDP.track('c_add_more_profile', {
                        // 查看活动规则
                        c_click_campaign_rule: this.isMemberProtocol ? '是' : '否',
                        // 头像
                        c_avatar: "",
                        // 昵称
                        c_nickname: this.name,
                        // 性别
                        c_gender: this.selectSexValue,
                        // 邮箱
                        // c_email: this.email,
                        // 手机号
                        c_mobile: "",
                        // 家庭成员人数
                        c_fam_number: this.selectFamilyName,
                        // 12岁以下宝宝人数
                        c_kid_number: this.selectBabyText,
                    })

                    this.$service('updateUserForPointMarketing').success(res => {
                        Toast.clear();
                        Toast(res || '更新成功');
                        this.isRequest = false;
                        return this.backPage();
                    }).error((err, result) => {
                        this.isRequest = false;
                        const xhr = result.xhr || {};
                        // 获取接口报文信息
                        let {errCode, errMsg, data = {}} = JSON.parse(xhr.response || xhr.responseText || '{}')
                        Toast.clear();

                        // 当前接口信息已经处理，需更新页面数据
                        if (errCode == '31076') {
                            // 更新用户信息
                            this.request().then(() => {
                                Toast(errMsg);
                            });
                        } else {
                            Toast(errMsg);
                        }
                    }).send(Object.assign({
                        // 未成年同意时间
                        // minorAgreeTime: isAgreeMinorAgreement("Birth") || undefined,
                        // childAgreeTime
                        childAgreeTime: isAgreeMinorAgreement() || undefined,
                    }, sendData));

                } else {
                    // 提取错误信息
                    let errField = this.$validator.errors.items[0];
                    Toast(errField.msg)
                }
            });
        },
        // 生日选择
        selectBirthday() {
            // 是否小于14岁
            if (isLtAge($Date.convert(this.selectBirthdayValue), 14)) {
                this.showBirthday = true
            } else if (!this.isInitBirthday) {
                this.showBirthday = true
            } else {
                Toast('设置生日，设置后不可修改')
            }
        },
        // 家庭人数弹窗框打开事件(用于打开时候直接定位到上次选择的位置)
        familyOpen(info) {
            if (info.value) {
                this.$refs.familyPicker.setColumnIndex(
                    0,
                    this.familyList.findIndex(info => info.name == this.selectFamilyName)
                );
            }
        },
        //  家庭人数选择事件
        familySelcet(vals) {
            const info = vals[0];
            this.showFamily = false;
            this.selectFamilyName = info.name;
            this.selectFamilyValue = info.value;
        },
        // 性别选择弹窗打开事件
        sexOpen(info) {
            info.value && this.$refs.sexPicker.setColumnIndex(0, this.sexList.findIndex(info => info.value == this.selectSexValue))
        },
        // 性别选择
        sexSelect(vals) {
            const info = vals[0];
            this.showSex = false;
            this.selectSexValue = info.value;
        },
        // 宝宝人数选择弹窗打开事件
        babyOpen(info) {
            info.value && this.$refs.babyPicker.setColumnIndex(0, this.babyList.findIndex(info => info.text == this.selectBabyText))
        },
        // 宝宝人数选择
        babySelcet(vals) {
            const info = vals[0];
            this.showBaby = false;
            this.selectBabyText = info.text;
            this.selectBabyValue = info.value
            // 宝宝生日信息序列化
            this.babyInfoList = info.value ? new Array(info.value).fill({}).map((info, index) => {
                return this.babyInfoList[index] || {
                    index,
                    age: null,
                    birthday: null,
                    birthdayText: null,
                }
            }) : [];
        },
        // 修改用户生日
        beforeUpdateBirthday(val) {
            this.showBirthday = false;
            // 检查是否小于18岁且是否同意过未成年协议（废弃）
            if (false && isLtAge(val, 18) && !isAgreeMinorAgreement("Birth")) {
                this.selectTemptBirthday = val
                this.showMinorPrivacyProtocol = true
            } else {
                this.selectBirthdayValue = val.getTime();
                this.selectBirthdayText = $Date.convert(val, "yy年mm月dd日");
            }
        },
        // 打开宝宝选择生日
        openBabyInfo(index) {
            // 检查是否同意未成年人协议
            if (isAgreeMinorAgreement()) {
                this.selectBabyIndex = index;
                this.showBabyBirthday = true;
            } else {
                this.showMinorPrivacyProtocol = true
            }
        },
        // 修改宝宝生日
        selectBabyBirthday(val) {
            this.showBabyBirthday = false;
            const babyInfo = this.babyInfoList[this.selectBabyIndex];

            babyInfo.birthday = $Date.convert(val).getTime();
            babyInfo.birthdayText = $Date.convert(val, "yy年mm月");
        },
        // 弹出框时间序列化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },
        // 兼容ios滚动问题
        scrollShim() {
            let container = this.$refs.memberMain;
            this.$nextTick(() => {
                let scrollTop = container.scrollTop;
                container.scrollTop = scrollTop = scrollTop + 1;
                container.scrollTop = scrollTop - 1;
            })
        },
        // 匿名用户绑定成功
        successBind({newMember}) {
            // 检查是否会员
            if (!newMember) {
                this.request();
            } else {
                // 跳转四选二
                this.$router.push('/my/member/memberSelectGift')
            }
        },
        // 会员章程同意
        beforeConfirmProtocol(done) {
            this.isMemberProtocol = true;
            // 检查是否会员章程协议展示
            if (this.nowMemberProtocolInfo.code != this.memberAgreementCode) {
                this.memberProtocolTitle = this.memberAgreementCode;
                return done(false);
            }
            done();
            this.showMemberProtocol = false;
        },
        // 会员章程取消
        beforeCancelProtocol() {
            this.showMemberProtocol = false;
            this.isMemberProtocol = false;
        },
        // 会员章程内部切换
        memberProtocolToggle({memberAgreementInfo, nowProtocolInfo, code}) {
            // 当前协议信息（）
            this.nowMemberProtocolInfo = nowProtocolInfo;
            // 检查是否会员章程
            if (code == this.memberAgreementCode) {
                this.memberProtocolShowCancel = true;
                this.memberProtocolConfirmText = '确定';
            } else {
                this.memberProtocolShowCancel = false;
                this.memberProtocolConfirmText = '返回' + memberAgreementInfo.title;
            }
        },
        // 打开协议弹窗
        openMemberProtocol() {
            this.showMemberProtocol = true;
        },
        // 检查是否匿名用户
        chechBindPhone() {
            // 检查是否 匿名用户
            if (this.anonymous) {
                // 弹出手机号码绑定
                this.showBindPhone = true;
            } else {
                Toast('手机号已绑定')
            }
        },
        // 检查是否匿名用户
        chechAnonymous() {
            // 检查是否 匿名用户
            if (this.anonymous) {
                Dialog.confirm({
                    message: '亲，请先绑定手机号码，即可修改信息。',
                    cancelButtonText: '取消',
                    confirmButtonText: '去绑定',
                }).then(() => {
                    // 弹出手机号码绑定
                    this.showBindPhone = true;
                }).catch(() => {

                });
                // 阻止捕获事件
                event.stopPropagation();
                document.activeElement.blur();
            }
        },
        // 返回上一页
        backPage() {
            // 检查是否积分商城跳转过来的
            let referrerInfo = window.document.referrer.match(/pmall(?:.+)?.dominos.com.cn([\s\S]*)/)
            if (referrerInfo) {
                return this.$toIntegralShop(referrerInfo[1]);
            }
            return this.$backPage();
        },
        // 宝宝生日选择展示
        showBabyOpen() {
            // 检查是否同意未成年人协议
            if (isAgreeMinorAgreement()) {
                this.showBaby = true
            } else {
                this.showMinorPrivacyProtocol = true
            }
        },
        // 取消未成年人协议
        beforeCancelMinorProtocol(done) {
            done();
            this.selectTemptBirthday = undefined
            // CDP埋点 [未成年人协议选择]
            Vue.$CDP.track('c_teenager_agreement', {
                c_buttonName: "不同意",
                c_buttonId: "",
            })
        },
        // 同意未成年人协议
        beforeConfirmMinorProtocol(done) {
            let val = this.selectTemptBirthday
            agreeMinorAgreement(val && "Birth")
            // 生日来源
            if (val) {
                this.selectTemptBirthday = undefined
                this.selectBirthdayValue = val.getTime();
                this.selectBirthdayText = $Date.convert(val, "yy年mm月dd日");
            }

            done();
            // CDP埋点 [未成年人协议选择]
            Vue.$CDP.track('c_teenager_agreement', {
                c_buttonName: "同意",
                c_buttonId: "",
            })
        }
    },
    computed: {
        // nav 样式
        navStyle() {
            let color = `rgba(255, 255, 255, ${1 - this.scrollScale})`;
            if (this.scrollScale > 0.5) {
                color = `rgba(0, 0, 0, ${this.scrollScale - (0.5 * (1 - this.scrollScale))})`;
            }
            return {
                color: color,
                boxShadow: `rgba(44, 44, 44, ${this.scrollScale}) -1px 0px 5px`,
                background: `rgba(255, 255, 255, ${this.scrollScale})`
            }
        },
    }
}
</script>

<style lang="scss" scoped>
$headerBgColor: #2E2520;
$padding: 15px;
$headerHeight: 55px;
$cardColor: #745227;
$vipScale: 55%;
.member-body {
    height: 100%;
    overflow: hidden;
    position: relative;
}

.main-body-content, .main-container, .time-title, .explain-container, .pizza-container {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.main-body-content {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: #000000;
    background: url('~@app/my/member/_img/member/wx_infoBg.png');
}

.member-nav {
    top: 0;
    width: 100%;
    height: $headerHeight;
    z-index: 10;
    position: absolute;

    ul {
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: row;
        flex-flow: row nowrap;
        justify-content: space-evenly;
    }

    li {
        flex-grow: 1;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &:not(:nth-child(2)) {
            width: 2rem;
            flex-grow: 0;
            font-weight: 600;
        }

        &:nth-child(2) {
            span {
                /*color: #fbe7bb;*/
                font-size: 16px;
                font-weight: 900;
            }
        }

        &:first-child {
            span {
                font-size: 16px;
            }

            i {
                font-size: .5rem;
            }
        }

        &:last-child {
            i {
                top: -5px;
                font-weight: 100;
                font-size: 26px;
                position: relative;
            }
        }

        i {
            width: .5rem;
            height: .5rem;
        }
    }
}

/deep/ {
    .van-circle {
        transform: initial !important;
    }
}

.gift-container {
    width: 100%;
    min-height: 100%;

    img {
        width: 100%;
        display: block;
    }
}

.member-nav > .title-container {
    .title-right {
        color: red;
        /*width: 4.5rem;*/
        display: flex;
        align-items: center;
        align-content: center;

        span {
            font-size: 16px;
        }

        i {
            padding-top: 5px;
            font-size: 18px;
            display: inline;
            font-weight: 800;
        }

    }
}

// 标题
.gift-header {
    color: #D3B176 !important;
    // padding-top: 5px;
    position: relative;
    background-size: cover;
    background-color: #0A0A0A;
    background-image: url("~@app/my/member/_img/bg.png");

    .header-cover {
        width: 100%;
        height: 35px;
        bottom: 0px;
        z-index: -1;
        position: absolute;
        background-color: #151616;
    }
}

// 内容
.gift-content {
    width: 100%;
    padding-top: 5px;
    padding-left: 12px;
    padding-right: 12px;
    position: absolute;
    top: 40px;
}

// 描述
.gift-describe {
    h5 {
        color: #000;
        font-size: 17px;
        padding-top: 2px;
        text-align: left;
        padding-bottom: 2px;
    }

    p {
        color: #b70e14;
        font-size: 13px;
        text-align: center;
    }
}

.gift-user-info {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;

    .user-form {
        li {
            padding-bottom: 7px;

            div {
                border: 1px solid #000;
            }

            &.err .input-container {
                /*border: solid 1px red;*/
            }
        }

        ul {
            padding-top: 7px;
        }
    }

    .input-container {
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 5px;
        background-color: white;
        border: solid 1px transparent;
        justify-content: space-between;

        &.disable {
            color: #8e8e8e;
            /*pointer-events: none;*/
        }

        > strong {
            height: 25px;
            display: flex;
            padding-left: 10px;
            align-items: center;

            img {
                width: 20px;
                height: 18px;
            }

            span {
                color: #6D6E70;
                padding-left: 3px;
                font-weight: normal;
            }
        }

        input {
            color: #4a4a4b;
            height: 36px;
            flex: 1;
            border: 0;
            text-align: right;

            &::placeholder {
                color: #C0C1C3;
            }
        }

        > p {
            flex: 1;
            color: #C0C1C3;
            text-align: right;

            &.exist {
                color: #4a4a4b;
            }
        }

        > i {
            color: #C0C1C3;
            font-size: 14px;
            padding-right: 5px;
        }
    }

    .btn-show {
        width: 100%;
        height: 39px;
        display: flex;
        align-items: center;
        /*justify-content: space-around;*/
        justify-content: center;
        background-size: 100% 100%;
        background-color: transparent;
        background-repeat: no-repeat;
        background-image: url("~@app/my/member/_img/memberSelectGift/按钮-1.png");

        span {
            color: #45200D;
        }

        i.dmicon {
            padding-left: 10px;
            color: #45200D;
            font-size: 16px;
            font-weight: 800;
        }
    }
}

.form-submit {
    padding-top: 15px;
    padding-bottom: 20px;

    .btn-submit {
        width: 100%;
        height: 39px;
        border: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #EDD394;
        text-align: center;
        background-size: 100% 100%;
        background-color: transparent;
        background-repeat: no-repeat;
        background-image: url("~@app/my/member/_img/memberSelectGift/按钮-2.png");
    }
}

.addMember-ul {
    color: white;
    padding-bottom: 20px;

    li {
        padding-bottom: 5px;
    }
}

.protocol-select {
    span {
        color: #a6a9ac;
        font-size: 14px;
        display: flex;
        justify-items: center;
        align-items: center;

        i {
            height: 20px;
            width: 20px;
            font-size: 12px;
            position: initial;
            align-items: center;
            border: solid 1px #c9c9c9;
            display: inline-flex;
            margin-right: 5px;
            border-radius: 20px;
            justify-items: center;
            align-items: center;
            justify-content: center;

            &:before {
                font-weight: 800;
                transform: scale(0);
            }
        }

        &.focus {
            i {
                border-color: #f22c37;
                background-color: #f22c37;

                &:before {
                    color: white;
                    font-weight: 800;
                    text-shadow: 0 0 15px white;
                    transform: translateY(1px) scale(1);
                }
            }
        }

        em {
            color: #27a6d9;
            font-size: 14px;
        }

        a {
            color: #f22c37;
            font-size: 14px;
            padding-right: 5px;
        }
    }
}

.baby-list-main {
    padding-top: 10px;

    > p {
        color: #f8db91;
        padding-bottom: 5px;
    }
}

.baby-list-container {
    overflow: hidden;
    border-radius: 5px;
    background-color: white;
    padding-top: 0 !important;
}

.baby-info {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: white;
    justify-content: space-between;
    padding-bottom: 0 !important;
    border-bottom: solid 1px #efefef;

    strong {
        width: 80px;
        color: #6D6E70;
        padding-left: 15px;
        font-weight: normal;
    }

    .baby-info-select-input {
        flex: 1;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > p {
            flex: 1;
            color: #C0C1C3;
            text-align: right;

            &.exist {
                color: #4a4a4b;
            }
        }

        > i {
            color: #C0C1C3;
            font-size: 14px;
            padding-left: 5px;
            padding-right: 5px;
        }
    }
}

.activity-explain {
    color: white;
    padding-top: 7px;
    padding-bottom: 2px;

    button {
        color: red;
        padding: 3px 8px;
        border-radius: 15px;
        border: solid 1px red;
        background: transparent;
    }
}


</style>